import { motion } from 'framer-motion';
// material
import { styled } from '@material-ui/core/styles';
import { Box, Typography, Container } from '@material-ui/core';
// components
import useGetMOTD from '../hooks/useGetMOTD';
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function PageMaintenanceMode() {
  const { message: motdMessage } = useGetMOTD();

  return (
    <RootStyle title="Maintenance Mode">
      <Container data-testid="maintenance-mode">
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Sorry, VRack is currently in Maintenance mode!
              </Typography>
            </motion.div>
            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src="/static/illustrations/maintenance.png"
                sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 }, padding: 2 }}
              />
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>{motdMessage}</Typography>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
